import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import { polyfill } from 'react-lifecycles-compat';
import MonthTable from './MonthTable';
import DateInput from '../date/DateInput';
import moment from 'moment';

function goYear(direction) {
  var next = this.state.value.clone();
  next.add(direction, 'year');
  this.setAndChangeValue(next);
}

function noop() {}

var MonthPanel = /*#__PURE__*/function (_React$Component) {
  _inherits(MonthPanel, _React$Component);

  var _super = _createSuper(MonthPanel);

  function MonthPanel(props) {
    var _this;

    _classCallCheck(this, MonthPanel);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "setAndChangeValue", function (value) {
      _this.setValue(value);

      _this.props.onChange(value);
    });

    _defineProperty(_assertThisInitialized(_this), "setAndSelectValue", function (value) {
      _this.setValue(value);

      _this.props.onSelect(value);
    });

    _defineProperty(_assertThisInitialized(_this), "setValue", function (value) {
      if (!('value' in _this.props)) {
        _this.setState({
          value: value
        });
      }
    });

    _this.nextYear = goYear.bind(_assertThisInitialized(_this), 1);
    _this.previousYear = goYear.bind(_assertThisInitialized(_this), -1);
    _this.prefixCls = "".concat(props.rootPrefixCls, "-month-panel");
    _this.state = {
      value: props.value || props.defaultValue
    };
    return _this;
  }

  _createClass(MonthPanel, [{
    key: "render",
    value: function render() {
      var props = this.props;
      var value = this.state.value;
      var locale = props.locale,
          cellRender = props.cellRender,
          contentRender = props.contentRender,
          renderFooter = props.renderFooter,
          rootPrefixCls = props.rootPrefixCls;
      var year = value.year();
      var prefixCls = this.prefixCls;
      var footer = renderFooter && renderFooter('month');
      return /*#__PURE__*/React.createElement("div", {
        className: prefixCls,
        style: props.style,
        tabIndex: "0"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-header")
      }, /*#__PURE__*/React.createElement("a", {
        className: "".concat(prefixCls, "-prev-year-btn"),
        role: "button",
        onClick: this.previousYear,
        title: locale.previousYear
      }), /*#__PURE__*/React.createElement("a", {
        className: "".concat(prefixCls, "-year-select"),
        role: "button",
        onClick: props.onYearPanelShow,
        title: locale.yearSelect
      }, /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-year-select-content")
      }, year), /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-year-select-arrow")
      }, "x")), /*#__PURE__*/React.createElement("a", {
        className: "".concat(prefixCls, "-next-year-btn"),
        role: "button",
        onClick: this.nextYear,
        title: locale.nextYear
      })), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-body")
      }, /*#__PURE__*/React.createElement(MonthTable, {
        disabledDate: props.disabledDate,
        onSelect: this.setAndSelectValue,
        locale: locale,
        value: value,
        cellRender: cellRender,
        contentRender: contentRender,
        prefixCls: prefixCls
      })), footer && /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-footer")
      }, footer)));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      var newState = {};

      if ('value' in nextProps) {
        newState = {
          value: nextProps.value
        };
      }

      return newState;
    }
  }]);

  return MonthPanel;
}(React.Component);

_defineProperty(MonthPanel, "propTypes", {
  onChange: PropTypes.func,
  disabledDate: PropTypes.func,
  onSelect: PropTypes.func,
  renderFooter: PropTypes.func,
  rootPrefixCls: PropTypes.string,
  value: PropTypes.object,
  defaultValue: PropTypes.object
});

_defineProperty(MonthPanel, "defaultProps", {
  onChange: noop,
  onSelect: noop
});

polyfill(MonthPanel);
export default MonthPanel;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-datepicker/src/rc-calendar/month/MonthPanel.js